module.exports = __webpack_public_path__ + "img/trade-icon-3.0655a445.svg";